import React from 'react';
import { Button } from 'framework/ui/mui-builder';
import { useVendorId, useVendorsUrl } from 'domain/finance/vendors/routes';
import { useNavigate } from 'react-router-dom';
import { useAuthorization } from 'framework/authorization';
import { useShowContext } from 'framework/show';
import { VendorDto } from 'domain/finance/vendors/types';
import HandshakeIcon from '@mui/icons-material/Handshake';
import { VENDOR_FINALIZE, VENDOR_PROFILE_STATUSES, VENDOR_WORKING_STATUSES } from 'domain/finance/vendors/constants';

const AgreementVendorButton = () => {
  const id = useVendorId();
  const navigate = useNavigate();
  const { isGranted } = useAuthorization();
  const { data } = useShowContext<VendorDto>();
  const { isCompliant, workingStatus, profileStatus } = data.getData();

  const { getAgreementVendorUrl } = useVendorsUrl();

  const handleRedirect = () => {
    navigate(getAgreementVendorUrl(id));
  };

  return isGranted(VENDOR_FINALIZE) &&
    isCompliant &&
    profileStatus === VENDOR_PROFILE_STATUSES.APPROVED &&
    workingStatus === VENDOR_WORKING_STATUSES.INACTIVE ? (
    <Button onClick={handleRedirect} variant="contained" color="primary" startIcon={<HandshakeIcon />}>
      Agreement
    </Button>
  ) : null;
};

export default AgreementVendorButton;
